import { Avatar } from '@robinpowered/ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import { CSSProperties } from 'react';

type Props = {
  name?: string | null;
  avatar?: string | null;
  style?: CSSProperties;
};

// A collapsed nav menu item is a flex container whose content box is sized for
// antd's 16px icon glyph, so an avatar dropped into the `icon` slot is a flex
// item with far less room than it needs. Its height is untouched, so letting it
// shrink renders it as a narrow oval — pin the width with flex-shrink: 0 and
// let it overflow into the item's padding instead. Callers can still layer
// their own styles on top.
const noShrink: CSSProperties = { flexShrink: 0 };

export const RobinAvatar = ({ avatar, name, style }: Props) => {
  return (
    <>
      {avatar ? (
        <Avatar
          size={'small'}
          src={avatar}
          name={name || ''}
          alt={name || ''}
          data-testid="avatar-with-image"
          style={{ ...noShrink, ...style }}
        >
          <FontAwesomeIcon icon={faUser} />
        </Avatar>
      ) : name ? (
        <Avatar
          size={'small'}
          name={name}
          alt={name || ''}
          data-testid="avatar-with-name"
          style={{ ...noShrink, ...style }}
        />
      ) : (
        <Avatar
          size={'small'}
          icon={<FontAwesomeIcon icon={faUser} />}
          alt={name || ''}
          data-testid="avatar-with-icon"
          style={{ ...noShrink, ...style }}
        />
      )}
    </>
  );
};
